import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TextField,
  Typography,
  TableContainer,
  TablePagination,
} from "@material-ui/core";

import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";

import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";

import ChevronDown from "../../UI/ChevronDown";
import AlertCircle from "../../UI/AlertCircle";
import CheckCircle from "../../UI/CheckCircle";
import LetterX from "../../UI/LetterX";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";

import { getLocalidadesPorZonaSegunPractica, setearValorEnPractica } from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRACTICAS_ESTADOS, AUTORIZACIONES_TIPO_EFECTOR, PROVINCIAS, TIPOS_AUTORIZACIONES } from "../../../../utils/constants";
import { TablePaginationActions } from "../../../compartidos/TablePaginationActions";
import { startAlerta } from "../../../../actions/ui/alertas";
import { getZonasEfectorSegunPractica } from "../../../../actions/contrataciones/contratacionesCartilla";

export const AutorizacionesAccordionEfector = (props) => {
  const dispatch = useDispatch();

  const { zonas = [] } = useSelector((state) => state.contratacionesCartilla);
  const { solicitudSeleccionada, localidades = [] } = useSelector((state) => state.autorizaciones);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [nombreBusquedaEfector, setNombreBusquedaEfector] = useState("");
  const [idZona, setIdZona] = useState("");
  const [idLocalidad, setIdLocalidad] = useState("");
  const [localidadDisabled, setLocalidadDisabled] = useState(false);
  const [efectores, setEfectores] = useState([]);
  const [copiarEfectorF, setCopiarEfectorF] = useState(false);
  const [efectorSeleccionado, setEfectorSeleccionado] = useState(
    props.preEfector
  );

  const { showZonaLocalidad = true } = props;

  useEffect(() => {
    if (showZonaLocalidad)
      dispatch(getZonasEfectorSegunPractica(props.practica?.practica?.codNom, solicitudSeleccionada?.conInternacion));
  }, []);

  const limpiarBuscador = () => {
    setNombreBusquedaEfector("");
    setIdZona("");
    setIdLocalidad("");
  };

  const onChangeZonaHandler = (e) => {
    const idZona = e.target.value;
    setIdZona(idZona);

    if (idZona > 0) {
      if (idZona === PROVINCIAS.CABA) {
        setLocalidadDisabled(true);
        setIdLocalidad("");
      } else {
        setLocalidadDisabled(false);
        //dispatch(getLocalidadesPorZona(idZona));
        dispatch(getLocalidadesPorZonaSegunPractica(idZona, props.practica?.practica?.codNom, solicitudSeleccionada?.conInternacion));
      }
    }
  };

  const handleSendCopiarEfectorF = (value) => {
    props.setearCopiarEfectorF(value);
    setCopiarEfectorF(false);
  };

  const onSubmitConsultaHandler = (e) => {
    e.preventDefault();

    if (efectores?.length === 0) {
      const data = {
        idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
        fechaProgramada: solicitudSeleccionada.conInternacion
          ? new Date(solicitudSeleccionada.fechaProgramada).toISOString()
          : new Date().toISOString(),
        codigoPractica: props.practica?.practica?.codNom,
        nombre: nombreBusquedaEfector,
        idLocalidad,
        idZona,
        conInternacion: solicitudSeleccionada?.conInternacion
      };


      if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION) {
        if (nombreBusquedaEfector === '') {
          dispatch(startAlerta("Debe completar el filtro de Nombre/Cuit", "warning"))
        } else {
          dispatch(props.traerEfectores(TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION, nombreBusquedaEfector, setEfectores));
        }
      } else if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO) {
        dispatch(props.traerEfectores({ ...data, idSolicitud: solicitudSeleccionada.idSolicitud }, setEfectores));
      }
      else {
        if (nombreBusquedaEfector === '' && idZona === '') {
          dispatch(startAlerta("Debe completar al menos un filtro de (Nombre/Cuit y/o Zona)", "warning"))
        } else {
          dispatch(props.traerEfectores(data, setEfectores));
        }
      }


    } else {
      setEfectores([]);
      props.setearEfector(null);
      setIdZona("");
      setIdLocalidad("");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getTitle = (idTipoEfector) => {
    switch (idTipoEfector) {
      case AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL:
        return 'Institucional';
      case AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL:
        return 'Profesional';
      case AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL_Y_PROFESIONAL:
        return 'Institucional y Profesional';
      case AUTORIZACIONES_TIPO_EFECTOR.INSTITUCINOAL_DISPONIBLE:
        return 'Institucional Disponible';
      default:
        return 'Tipo de efector no declarado';
    }
  }

  const disabledDatosContacto = /*solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||*/ props.disabled;

  // console.log("solicitudSeleccionada.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.LABORATORIO", solicitudSeleccionada.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.LABORATORIO);


  return (
    <Accordion TransitionProps={{ unmountOnExit: true }} style={{ marginLeft: 45 }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          Efector {getTitle(props.idTipoEfector)}
          {props.estaCorrecto ? <CheckCircle /> : <AlertCircle />}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {!!efectorSeleccionado ? (
          <Grid container spacing={1} style={{ marginTop: "1.5rem" }}>
            <div
              style={{
                padding: "1rem",
                marginBottom: "0.5rem",
                marginRight: "1rem",
                marginLeft: "1rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((!props.esDenunciaInternacion && !props.disabled &&
                (props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
                  || props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION)) || 
                  solicitudSeleccionada.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.LABORATORIO) && (
                  <LetterX
                    deleteFunction={() => {
                      dispatch(startSpinner());
                      props.setearEfector(null);
                      if (props.setearEfectorP) props.setearEfectorP(null);
                      if (props.idTipoEfector !== AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL) {
                        props.setearContactoEfectorI({
                          target: { name: "emailEfectorI", value: null },
                        });
                        props.setearContactoEfectorI({
                          target: { name: "celularEfectorI", value: null },
                        });
                      }
                      setEfectorSeleccionado(null);
                      if (props.setearCopiarEfectorF)
                        props.setearCopiarEfectorF(false);
                      dispatch(finishSpinner());
                    }}
                    styles={{
                      cursor: "pointer",
                      position: "relative",
                      top: "0.15rem",
                      marginRight: "0.5rem",
                    }}
                  />
                )}
              <Typography
                variant="h6"
                style={{ flexGrow: 1, fontSize: "1rem", fontStyle: "italic" }}
              >
                {props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL
                  ? efectorSeleccionado?.nombreApellido
                  : solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
                    ? efectorSeleccionado?.cartillaPrestadores?.prestador?.nombreApellido
                    : !props.preEfector ? efectorSeleccionado?.efectorFacturacionRazonSocial : props.practica?.efectorFacturacion?.razonSocial
                }
              </Typography>
              {(props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL ||
                props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL_Y_PROFESIONAL ||
                props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCINOAL_DISPONIBLE) &&
                solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && (
                  <>
                    <TextField
                      error={
                        props.emailEfectorIError
                          ? props.emailEfectorIError
                          : false
                      }
                      margin="normal"
                      style={{ marginLeft: 50, marginTop: -20, minWidth: 300 }}
                      name="emailEfectorI"
                      label="Email"
                      disabled={disabledDatosContacto}
                      value={props.emailEfectorI}
                      autoComplete="off"
                      onChange={props.setearContactoEfectorI}
                      helperText={
                        props.emailEfectorIError
                          ? "El formato del Email es invalido"
                          : ""
                      }
                    />
                    <TextField
                      error={
                        props.celularEfectorIError
                          ? props.celularEfectorIError
                          : false
                      }
                      margin="normal"
                      style={{ marginLeft: 25, marginTop: -20, minWidth: 150 }}
                      name="celularEfectorI"
                      label="Celular"
                      disabled={disabledDatosContacto}
                      value={props.celularEfectorI}
                      autoComplete="off"
                      onChange={props.setearContactoEfectorI}
                      helperText={
                        props.celularEfectorIError
                          ? "Cel. (10 dig. sin 0 ni 15)"
                          : ""
                      }
                    />
                  </>
                )}
            </div>
            {(props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL ||
              props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL_Y_PROFESIONAL ||
              props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCINOAL_DISPONIBLE) && (
                <div
                  style={{
                    padding: "1rem",
                    marginBottom: "0.5rem",
                    marginRight: "1rem",
                    marginLeft: "2.5rem",
                    marginTop: "-1.5rem",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    label="Cuit Efector Fact"
                    value={efectorSeleccionado?.efectorFacturacionCuit ? efectorSeleccionado?.efectorFacturacionCuit : props.practica?.efectorFacturacion?.cuit}
                    style={{ width: 100, marginRight: 10 }}
                    disabled
                  />
                  {solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
                    <>
                      <TextField
                        label="Efector Facturacion"
                        value={efectorSeleccionado?.efectorFacturacionRazonSocial ? efectorSeleccionado?.efectorFacturacionRazonSocial : props.practica?.efectorFacturacion?.razonSocial}
                        style={{ width: 300, marginRight: 10 }}
                        disabled
                      />
                      <TextField
                        label="Domicilio"
                        value={`${efectorSeleccionado?.domicilio} - ${efectorSeleccionado?.localidad?.descripcion_localidad} - ${efectorSeleccionado?.provincia?.descripcion_provincia}`}
                        style={{ minWidth: 450 }}
                        disabled
                      />
                    </>
                  }
                </div>
              )}
          </Grid>
        ) : (
          (!props.disabled || solicitudSeleccionada.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.LABORATORIO) && (
            <Grid container spacing={1}>
              <ValidatorForm
                onSubmit={onSubmitConsultaHandler}
                style={{ flexGrow: "1", margin: "1rem" }}
              >
                {efectores?.length === 0 && (
                  <React.Fragment>
                    <Grid container spacing={2}>
                      <Grid item xs={1} sm={1} md={2} lg={3} />
                      <Grid item xs={10} sm={10} md={8} lg={6}>
                        <TextValidator
                          fullWidth
                          margin="normal"
                          label="Nombre/Cuit Efector"
                          disabled={props.esDenunciaInternacion}
                          name="nombreBusquedaEfector"
                          value={nombreBusquedaEfector}
                          onChange={(e) =>
                            setNombreBusquedaEfector(e.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={1} sm={1} md={2} lg={3} />
                      {showZonaLocalidad && (
                        <React.Fragment>
                          <Grid item xs={1} sm={1} md={2} lg={3} />
                          <Grid item xs={10} sm={10} md={8} lg={6}>
                            <SelectValidator
                              fullWidth
                              margin="normal"
                              label="Zona"
                              name="idZona"
                              value={idZona}
                              disabled={props.esDenunciaInternacion}
                              onChange={onChangeZonaHandler}
                            >
                              {zonas?.map((zona) => (
                                <MenuItem key={zona.id} value={zona.id}>
                                  {zona.descripcion}
                                </MenuItem>
                              ))}
                            </SelectValidator>
                          </Grid>
                          <Grid item xs={1} sm={1} md={2} lg={3} />
                          <Grid item xs={1} sm={1} md={2} lg={3} />
                          <Grid item xs={10} sm={10} md={8} lg={6}>
                            <SelectValidator
                              fullWidth
                              margin="normal"
                              label="Localidad"
                              name="idLocalidad"
                              value={idLocalidad}
                              disabled={
                                localidades?.length === 0 ||
                                props.esDenunciaInternacion || localidadDisabled
                              }
                              onChange={(e) => setIdLocalidad(e.target.value)}
                            >
                              {localidades?.map((localidad) => (
                                <MenuItem
                                  key={localidad.id_localidad}
                                  value={localidad.id_localidad}
                                >
                                  {localidad.descripcion_localidad}
                                </MenuItem>
                              ))}
                            </SelectValidator>
                          </Grid>
                          <Grid item xs={1} sm={1} md={2} lg={3} />
                        </React.Fragment>
                      )}
                    </Grid>
                  </React.Fragment>
                )}
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "2rem",
                    flexGrow: "1",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={props.esDenunciaInternacion}
                  >
                    {efectores?.length > 0 ? "Volver a consultar" : "Consultar"}
                  </Button>
                </Grid>
                {efectores?.length === 0
                  && <Grid
                    item
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "2rem",
                      flexGrow: "1",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      disabled={props.esDenunciaInternacion}
                      onClick={limpiarBuscador}
                    >
                      Limpiar buscador
                    </Button>
                  </Grid>}
              </ValidatorForm>
              {/* TABLE ROWS */}
              {efectores?.length > 0 && (
                <Grid item xs={12}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ width: "8%" }}></TableCell>
                          <TableCell style={{ width: "36%" }}>
                            Nombre del Efector
                          </TableCell>
                          {props.idTipoEfector !== AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL &&
                            solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && (
                              <TableCell style={{ width: "56%" }}>Domicilio</TableCell>
                            )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {efectores
                          ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((efector, index) => {
                            let nombre = solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA
                              ? efector.efectorFacturacionRazonSocial
                              : efector.prestadorNombreApellido;
                            let domicilio = `${efector?.domicilio} - ${efector?.provincia} - ${efector?.localidad}`
                            let email = efector?.email;
                            let celular = efector?.telefono;
                            // if (props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCIONAL) {
                            //   nombre = efector.prestadorNombreApellido;
                            //   domicilio = `${efector?.domicilio} - ${efector?.provincia} - ${efector?.localidad}`
                            //   email = efector?.email;
                            //   celular = efector?.telefono;
                            // } else if (props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL) {
                            //   nombre = efector.nombreApellido;
                            //   domicilio = efector.efectorDomicilio;
                            //   email = (efector?.efectorContactos ?? [])[0]?.email
                            //     ? (efector?.efectorContactos[0] ?? [])?.email
                            //     : null;
                            //   celular = (efector?.efectorContactos ?? [])[0]?.celular
                            //     ? (efector?.efectorContactos ?? [])[0]?.celular
                            //     : null;
                            // } else if (props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.INSTITUCINOAL_DISPONIBLE) {
                            //   nombre = efector?.prestadorNombreApellido;
                            //   domicilio = `${efector?.domicilio} - ${efector?.provincia} - ${efector?.localidad}`
                            //   email = efector?.email;
                            //   celular = efector?.telefono;
                            // }
                            return (
                              <TableRow key={index}>
                                <TableCell>
                                  <Checkbox
                                    onChange={() => {
                                      if (props.idTipoEfector === AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL) {
                                        props.setearEfector(efector.idPrestador);
                                      } else {
                                        props.setearEfector(
                                          efector.idEfectorFacturacion
                                        );
                                        if (props.setearEfectorP)
                                          props.setearEfectorP(
                                            efector.idCartillaPrestador
                                          );
                                        if (props.conInternacion)
                                          setCopiarEfectorF(true);
                                        dispatch(
                                          setearValorEnPractica(props.practica?.idCodNom, "celularEfectorI", celular)
                                        );
                                        dispatch(
                                          setearValorEnPractica(props.practica?.idCodNom, "emailEfectorI", email)
                                        );
                                      }
                                      let efectorFormat = {
                                        ...efector,
                                        nombreApellido: efector.prestadorNombreApellido,
                                        localidad: { descripcion_localidad: efector.localidad },
                                        provincia: { descripcion_provincia: efector.provincia },
                                        cartillaPrestadores: { prestador: { nombreApellido: efector.prestadorNombreApellido } }
                                      };
                                      setEfectorSeleccionado(efectorFormat)
                                    }}
                                  />
                                </TableCell>
                                <TableCell>{nombre}</TableCell>
                                {props.idTipoEfector !== AUTORIZACIONES_TIPO_EFECTOR.PROFESIONAL &&
                                  solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && (
                                    <TableCell>{domicilio}</TableCell>
                                  )}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    style={{ backgroundColor: "white" }}
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={efectores.length}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}`
                    }
                    labelRowsPerPage="Efectores por página"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </Grid>
              )}
              {/* TABLE ROWS */}
            </Grid>
          )
        )}
      </AccordionDetails>
      <AlertFinalizadoStepper
        open={copiarEfectorF}
        pregunta={"Copiar Efector Institucional?"}
        dialogText={
          "Se va a copiar el Efector Institucional en el Efector Profesional, esta seguro?"
        }
        buttonCancel={"No Copiar"}
        buttonSubmit={"Copiar"}
        handleClose={() => handleSendCopiarEfectorF(false)}
        handleSend={() => handleSendCopiarEfectorF(true)}
      />
    </Accordion>
  );
};
